import React, { useContext, useEffect, useState } from 'react'
import { trackDemoPlay } from 'tracking'
import { MediaPlayerContext } from 'contexts/PlayerContext'
import productNames from 'data/products/messagesShort'
import { FormattedMessage } from 'react-intl'
import classNames from 'classnames'
import { Icon, Button } from '@arnsbogroup/react-voicearchive'

export const DemoPlayButton = (
  {
    showProduct = true,
    voice,
    demo,
    className = '',
    iconOnly = false,
    childClassName = 'text-gray-600 group-hover:text-white inset-y-0 m-auto',
    component = 'NotSpecificed',
    ...props
  },
  ref
) => {
  const { load, player, playing, loadMeta } = useContext(MediaPlayerContext)

  const [playingUrl, setPlayingUrl] = useState('')

  useEffect(() => {
    if (player) {
      setPlayingUrl(player._src)
    }
  }, [player])

  const onClick = () => {
    if (playingUrl === demo.url) {
      if (playing) {
        player.pause()
      } else {
        player.play()
      }
    } else {
      load({
        src: demo.url,
        format: 'mp3',
      })
      loadMeta({
        id: demo.id,
        sku: voice.sku,
        displayName: voice.displayName,
        product: demo.product,
        voiceage: demo.voiceage,
        language: demo.language,
      })
      trackDemoPlay(`${component}.next.play.click`, { supplier: demo.supplier, demo: demo.id })
    }
  }
  const isPlaying = playingUrl === demo.url && playing

  return (
    <Button
      variant="plain"
      size="sm"
      onClick={onClick}
      className={classNames('inline-block', className)}
      ref={ref}
      {...props}
    >
      <Icon
        icon={['fas', isPlaying ? 'pause' : 'play']}
        className={childClassName}
      />

      {!iconOnly && (
        <span className="ml-1">
          { (showProduct && demo?.productSlug in productNames) ? (
            <FormattedMessage {...productNames[demo.productSlug]} />
          ) : (showProduct && demo?.product in productNames) ? (
            <FormattedMessage {...productNames[demo.product]} />
          ) : isPlaying ? (
            'Pause'
          ) : (
            'Play'
          )}
        </span>
      )}
    </Button>
  )
}

export default React.forwardRef(DemoPlayButton)
